import { useUser } from 'Components/Organisms/UserProvider/useUser';
import { useState } from 'react';
import DialogWithDelay from './DialogWithDelay';
import { sendOnboard } from 'Services/user';
import { trackError } from 'Utils/errorMonitoring';
import { useTracking } from 'Components/Organisms/TrackingProvider';
import OnboardingProfileData from './OnboardingProfileData.jsx';
import { useQueryClient } from '@tanstack/react-query';
import OnboardingFirstSteps from './OnboardingFirstSteps';

export default function OnboardingModal() {
    const { user, refreshUser } = useUser();
    const { track } = useTracking();

    const [waiting, setWaiting] = useState(false);
    const queryClient = useQueryClient();

    const [onboardingData, setOnboardingData] = useState(() => ({
        name: user.name,
        surnames: user.surnames,
        phone_number: user.phone_number,
    }));
    const [showFirstSteps, setShowFirstSteps] = useState(false);

    if (user.is_onboarded && !showFirstSteps) {
        return null;
    }

    const handleSubmit = async (data) => {
        setWaiting(true);
        setOnboardingData(data);

        try {
            const response = await sendOnboard(data);
            if (response?.event_id) {
                track('user_onboarded', response);
                await queryClient.invalidateQueries({ queryKey: ['projects'] });
            }
        } catch (error) {
            trackError(error);
        } finally {
            setWaiting(false);
            setShowFirstSteps(true);
        }
    };

    const handleCloseFirstSteps = () => {
        refreshUser({
            ...user,
            ...onboardingData,
            is_onboarded: true,
        });
        setShowFirstSteps(false);
    };

    return (
        <DialogWithDelay>
            {showFirstSteps && <OnboardingFirstSteps onClose={handleCloseFirstSteps} />}
            {!showFirstSteps && (
                <OnboardingProfileData
                    key="profile-data"
                    data={onboardingData}
                    onCompleted={handleSubmit}
                    isBusy={waiting}
                />
            )}
        </DialogWithDelay>
    );
}
